module.exports = __webpack_public_path__ + "media/images/thumbs/physanims/a9-2-5fe1fa71bebb97862bb1d7fc87c29196.jpg";